import type { ReactNode, PropsWithChildren } from 'react';

import {
  BpkBox,
  BpkFlex,
  BpkSpacing,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkSectionHeader from '@skyscanner-internal/backpack-web/bpk-component-section-header';

import FooterBlurb from '../common/FooterBlurb/index';

type CardStackProps = PropsWithChildren<{
  title?: string;
  subtitle?: string;
  children?: JSX.Element[];
  callToAction?: ReactNode;
  disclaimer?: string;
  contentDisplay?: 'flex' | 'block';
}>;

const CardStack = ({
  callToAction = null,
  children = [],
  contentDisplay = 'flex',
  disclaimer = undefined,
  subtitle = undefined,
  title = undefined,
}: CardStackProps) => {
  if (children.length === 0) {
    return null;
  }
  return (
    <BpkBox data-testid="CardStack">
      {title && (
        <BpkBox>
          <BpkSectionHeader title={title} description={subtitle} />
        </BpkBox>
      )}
      {contentDisplay === 'block' ? (
        <BpkBox marginTop={BpkSpacing.LG} data-testid="CardStackContent">
          {children}
        </BpkBox>
      ) : (
        <BpkFlex
          wrap="wrap"
          marginTop={BpkSpacing.LG}
          data-testid="CardStackContent"
        >
          {children}
        </BpkFlex>
      )}
      {callToAction}
      {disclaimer && (
        <BpkBox marginTop={BpkSpacing.LG}>
          <FooterBlurb disclaimerCopy={disclaimer} />
        </BpkBox>
      )}
    </BpkBox>
  );
};

export default CardStack;
